import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';

export default function QCXSelectMaterialAutocomplete({
    label,
    name,
    initialValues,
    ...restProps
}) {

    const [defaultValue, setDefaultValue] = useState('');

    const list = useMemo(
        () => [
            { label: 'ABOTOADURAS', value: 'ABOTOADURAS' },
            { label: 'ADMISSAO TEMPORARIA', value: 'ADMISSAO TEMPORARIA' },
            { label: 'ARTIGOS PROMOCIONAIS', value: 'ARTIGOS PROMOCIONAIS' },
            { label: 'ATIVO', value: 'ATIVO' },
            { label: 'CARTOES DE NATAL', value: 'CARTOES DE NATAL' },
            { label: 'CATALOGOS', value: 'CATALOGOS' },
            { label: 'ESTOJOS', value: 'ESTOJOS' },
            { label: 'ESTOJO PARA ABOTOADURAS', value: 'ESTOJO PARA ABOTOADURAS' },
            { label: 'FERRAMENTAS', value: 'FERRAMENTAS' },
            { label: 'FORNITURAS', value: 'FORNITURAS' },
            { label: 'MANUAIS PARA RELOGIOS', value: 'MANUAIS PARA RELOGIOS' },
            { label: 'MATERIAL PARA PONTO DE VENDAS', value: 'MATERIAL PARA PONTO DE VENDAS' },
            { label: 'PORTA CARTAO GARANTIA', value: 'PORTA CARTAO GARANTIA' },
            { label: 'PULSEIRAS', value: 'PULSEIRAS' },
            { label: 'RELOGIOS', value: 'RELOGIOS' },
        ],
        []
    );

    useEffect(() => {
        const defaultInitialValue = _.get(initialValues, name);
        const option = list.find((item) => item?.value === defaultInitialValue);

        if (option) {
            setDefaultValue(option);
        } else {
            setDefaultValue('');
        }
    }, [list, initialValues, name]);

    const filterOptions = useMemo(
        () =>
            createFilterOptions({
                stringify: (option) => option.label,
            }),
        []
    );

    const getOptionLabel = useCallback((item) => item?.label || '', []);
    const getOptionValue = useCallback((item) => item?.value || '', []);

    return (
        <QCXAutocompleteSelect
            label={label}
            id={name}
            name={name}
            options={list}
            filterOptions={filterOptions}
            defaultValue={defaultValue}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            {...restProps}
        />
    );
}